import { render, staticRenderFns } from "./mortgageCreate.vue?vue&type=template&id=1cbb36dc&scoped=true&lang=html&"
import script from "./mortgageCreate.vue?vue&type=script&lang=js&"
export * from "./mortgageCreate.vue?vue&type=script&lang=js&"
import style0 from "./mortgageCreate.vue?vue&type=style&index=0&id=1cbb36dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbb36dc",
  null
  
)

export default component.exports